import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    zqUserPhone: ''
  },
  getters: {
    zqUserPhone: state => state.zqUserPhone
  },
  mutations: {
    SET_ZQ_USER_PHONE(state, phone) {
      state.zqUserPhone = phone
    }
  },
  actions: {
    setZqUserPhone({ commit }, phone) {
      commit('SET_ZQ_USER_PHONE', phone)
    }
  }
})